<div class="campaign-main d-flex"
    *ngIf="activeCampaign"
    [ngClass]="{'maintenance': activeCampaign.campaignTypeId == 1,
                'release':activeCampaign.campaignTypeId == 2,
                'research':activeCampaign.campaignTypeId == 3,
                'warning':activeCampaign.campaignTypeId == 4}"
    [ngStyle]="{'background-color': activeCampaign.campaignType.backgroundColor, 'color': activeCampaign.campaignType.textColor}">
    <div class="campaign-icon-div d-grid align-items-start justify-content-center">
        <div class="svg-icon" [innerHTML]="activeCampaign.icon"></div>
    </div>
    <div class="campaign-text-div align-items-center justify-content-start">
        <div class="campaign-title" [ngStyle]="{'color':activeCampaign.campaignType.textColor}">
            <span [innerHTML]="campaignTitle"></span>
        </div>
        <div class="campaign-message" [ngStyle]="{'color':activeCampaign.campaignType.textColor}">
            <span [innerHTML]="campaignText"></span>
        </div>
    </div>
    <div class="campaign-controls align-items-center justify-content-end">
        <button type="button" class="close-btn" (click)="updateCampaignVisibility()">
            <mat-icon >close</mat-icon>
        </button>
        <button *ngIf="activeCampaign.link" class="campaign-link"
                [ngStyle]="{'border-color':activeCampaign.campaignType.buttonColor,
                            'color':activeCampaign.campaignType.buttonColor}"
                (click)="goToLink()">{{buttonText}}</button>
    </div>
</div>